import { render, staticRenderFns } from "./AProgramasContactos.vue?vue&type=template&id=4237eb8a"
import script from "./AProgramasContactos.vue?vue&type=script&lang=js"
export * from "./AProgramasContactos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports